import {
  PLANOGRAM_ERROR,
  FETCHED_PLANOGRAM,
  FETCHING_PLANOGRAM,
  PLANOGRAM_UPDATE,
} from './../actions/planogram';

const initialState = {
  fetching: false,
  data: null,
  error: null,
};

const planogramReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_PLANOGRAM:
      return {
        ...state,
        fetching: true,
      };
    case PLANOGRAM_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case FETCHED_PLANOGRAM:
      return {
        ...state,
        fetching: false,
        error: null,
        data: action.data,
      };
    case PLANOGRAM_UPDATE:
      if (!action.shelfNumber || !action.slot || !action.product) return state;

      let planogramData = { ...state.data };
      if (!planogramData || !('shelves' in planogramData)) return state;

      const planorgramShelves = planogramData.shelves.map(shelf => {
        if (action.shelfNumber !== shelf.shelf) return shelf;

        const slotData = (shelf.slots || []).map(slot => {
          if (slot.slot !== action.slot) return slot;

          return {
            ...slot,
            barcode: action.product.barcode,
            productId: action.product.id,
            products: [action.product.id],
          };
        });
        return {
          ...shelf,
          slots: slotData,
        };
      });

      planogramData = { ...planogramData, shelves: planorgramShelves };

      return {
        ...state,
        data: planogramData,
      };

    default:
      return state;
  }
};

export default planogramReducer;
